export default __webpack_public_path__ + "static/media/Close.1d7d9016.svg";